import React, { useEffect } from 'react';
import { graphql } from 'gatsby';
import ReactHtmlParser from 'react-html-parser';
import Layout from '../components/Layout';
import { useGlobalDispatch } from '../components/Context/globalContext';

const BasicPage = (props) => {
  const data = props.data.allNodePage.nodes;
  const { title, body } = data[0];
  const globalDispatch = useGlobalDispatch();
  
  useEffect(() => {
    globalDispatch({type: 'meta', payload: {pageTitle: title}});
  }, []);


  const displayData = () => {
    if (body) {
      return (
        <div>{ReactHtmlParser(body.processed)}</div>
      );
    }
  };

  return (
    <Layout>
      <div className="sta-basic-page">
        <h2 className="page-title">{title}</h2>
        <div className="basic-page-content">{displayData()}</div>
      </div>
    </Layout>
  );
};

export default BasicPage;

export const BasicPageQuery = graphql`
query($id: String!){
  allNodePage(filter: {drupal_id: {eq: $id}}) {
    nodes {
      title
      body {
        processed
      }
    }
  }
}`;
